export default __webpack_public_path__ + "static/media/prod-img.3ec7c7b5.png";